// @flow

/* eslint-disable max-len,react/jsx-tag-spacing */
import * as React from 'react';
import classNames from 'classnames';
// import { Responsive } from '../Responsive';
import * as css from './Icon.scss';

type Props = {|
	type: string,
	className?: string,
	width?: number,
	height?: number,
	color?: string,
|};

/**
 * @link - https://material.io/tools/icons/?style=baseline
 * @return {XML}
 */
const Icon = ({ type, className, width, height, color, ...iconProps }: Props) => {
	let icon = null;
	const svgProps = {
		width: width || 24,
		height: height || 24,
		viewBox: `0 0 ${width || 24} ${height || 24}`,
		xmlns: 'http://www.w3.org/2000/svg',
	};
	// const isDesktop = Responsive.isMatching(Responsive.DESKTOP);

	switch (type) {
		case 'plus':
			icon = (
				<svg {...svgProps}>
					<g id="Group_1244" data-name="Group 1244" transform="translate(-234.5 -597.5)">
						<rect
							id="Rectangle_391"
							data-name="Rectangle 391"
							className="cls-1"
							width="4"
							height="24"
							transform="translate(244.5 597.5)"
							fill="#468aff"
						/>
						<rect
							id="Rectangle_392"
							data-name="Rectangle 392"
							className="cls-1"
							width="24"
							height="4"
							transform="translate(234.5 607.5)"
							fill="#468aff"
						/>
					</g>
				</svg>
			);
			break;
		case 'whatsapp':
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<circle fill="#ADC6DC" cx="18.5" cy="18.5" r="18.5" />
						<path
							d="M18.5 8c1.375 0 2.695.266 3.96.797a10.923 10.923 0 0 1 3.4 2.25c1 1 1.773 2.133 2.32 3.398a9.884 9.884 0 0 1 .82 3.961c0 1.875-.477 3.61-1.43 5.203a10.658 10.658 0 0 1-3.843 3.797 10.205 10.205 0 0 1-5.227 1.406 10.13 10.13 0 0 1-4.969-1.265L8 29l1.5-5.39a10.08 10.08 0 0 1-1.406-5.204c0-1.875.468-3.61 1.406-5.203a10.53 10.53 0 0 1 3.797-3.797A10.08 10.08 0 0 1 18.5 8zm-3.14 5.625h-.563c-.25 0-.485.11-.703.328l-.047.047a2.964 2.964 0 0 0-.844 2.11c0 .812.344 1.702 1.031 2.671l.094.094c1.313 1.875 2.766 3.156 4.36 3.844.78.343 1.406.562 1.874.656.407.062.829.062 1.266 0 .281-.031.617-.18 1.008-.445.39-.266.64-.532.75-.797.11-.266.172-.524.187-.774.016-.25.008-.406-.023-.468-.031-.063-.156-.141-.375-.235l-.14-.094c-.938-.468-1.532-.75-1.782-.843a1.377 1.377 0 0 0-.328-.047c-.094 0-.172.062-.234.187a16.17 16.17 0 0 1-.844 1.032c-.125.156-.313.171-.563.046-.875-.437-1.53-.828-1.968-1.171-.594-.47-1.11-1.11-1.547-1.922-.094-.094-.125-.18-.094-.258.031-.078.11-.18.234-.305.25-.25.453-.531.61-.844.062-.125.047-.28-.047-.468l-.797-1.922c-.063-.188-.133-.305-.211-.352a.586.586 0 0 0-.305-.07z"
							fill="#212F3B"
							fillRule="nonzero"
						/>
					</g>
				</svg>
			);
			break;
		case 'facebook':
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<circle fill="#ADC6DC" cx="18.5" cy="18.5" r="18.5" />
						<path
							d="M15.203 29h4.407V18.558h2.802a.27.27 0 0 0 .27-.245l.27-3.15a.27.27 0 0 0-.271-.292h-3.07v-2.236c0-.524.429-.948.959-.948h2.16a.27.27 0 0 0 .27-.268V8.27A.27.27 0 0 0 22.73 8h-3.65c-2.14 0-3.877 1.716-3.877 3.834v3.037h-1.932a.27.27 0 0 0-.271.268v3.151a.27.27 0 0 0 .271.268h1.932V29z"
							fill="#212F3B"
						/>
					</g>
				</svg>
			);
			break;
		case 'copy':
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<circle cx="18.5" cy="18.5" r="18.5" fill="#ADC6DC" />
						<g fill="#212F3B">
							<path d="M25.472 17.41c-.42.42-.42 1.099 0 1.518.42.42 1.103.42 1.522 0l.76-.759c2.088-2.088 2.088-5.512 0-7.6-2.088-2.092-5.513-2.092-7.6 0l-3.403 3.398c-2.089 2.088-2.089 5.512.003 7.6a1.073 1.073 0 1 0 1.519-1.518 3.235 3.235 0 0 1 0-4.563l3.399-3.399a3.235 3.235 0 0 1 4.563 0 3.23 3.23 0 0 1 0 4.56l-.763.763z" />
							<path d="M12.808 20.516a1.101 1.101 0 0 0 0-1.536 1.05 1.05 0 0 0-1.505 0l-.752.77c-2.068 2.107-2.068 5.56 0 7.667a5.268 5.268 0 0 0 7.529 0l3.366-3.428c2.072-2.11 2.072-5.56 0-7.671a1.05 1.05 0 0 0-1.504 0 1.101 1.101 0 0 0 0 1.535c1.24 1.267 1.244 3.337 0 4.6l-3.37 3.432a3.165 3.165 0 0 1-4.517 0c-1.243-1.267-1.243-3.333 0-4.603l.753-.766z" />
						</g>
					</g>
				</svg>
			);
			break;
		case 'check':
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<circle cx="18.5" cy="18.5" r="18.5" fill="#ADC6DC" />
						<path
							transform="translate(7, 7)"
							fill="#212F3B"
							d="M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z"
						/>
					</g>
				</svg>
			);
			break;

		case 'share':
			icon = (
				<svg {...svgProps} fill="#fff">
					<path d="M 23 3 A 4 4 0 0 0 19 7 A 4 4 0 0 0 19.09375 7.8359375 L 10.011719 12.376953 A 4 4 0 0 0 7 11 A 4 4 0 0 0 3 15 A 4 4 0 0 0 7 19 A 4 4 0 0 0 10.013672 17.625 L 19.089844 22.164062 A 4 4 0 0 0 19 23 A 4 4 0 0 0 23 27 A 4 4 0 0 0 27 23 A 4 4 0 0 0 23 19 A 4 4 0 0 0 19.986328 20.375 L 10.910156 15.835938 A 4 4 0 0 0 11 15 A 4 4 0 0 0 10.90625 14.166016 L 19.988281 9.625 A 4 4 0 0 0 23 11 A 4 4 0 0 0 27 7 A 4 4 0 0 0 23 3 z" />
				</svg>
			);
			break;
		case 'whatsapp-black':
			icon = (
				<svg {...svgProps} width="37px" height="37px" viewBox="0 0 37 37">
					<g id="Design_Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="Desktop_tvbee_lobby_Recomendetaions" transform="translate(-942.000000, -877.000000)">
							<g id="Share_Icons" transform="translate(887.000000, 877.000000)">
								<g id="whatsapp" transform="translate(55.000000, 0.000000)">
									<circle id="Oval-Copy" fill="#212F3B" cx="18.5" cy="18.5" r="18.5"></circle>
									<path
										d="M18.499975,8 C19.8749714,8 21.195281,8.26562461 22.460903,8.7968731 C23.726525,9.3281216 24.859335,10.0781198 25.8593324,11.0468677 C26.8593298,12.0468651 27.6327655,13.1796752 28.1796394,14.4452971 C28.7265133,15.7109191 28.9999499,17.0312287 28.9999499,18.4062252 C28.9999499,20.2812207 28.5233883,22.0155916 27.5702658,23.6093378 C26.6171434,25.203084 25.3358959,26.468706 23.726525,27.4062037 C22.1171541,28.3437015 20.3749705,28.8124504 18.499975,28.8124504 C16.7187292,28.8124504 15.0624834,28.3905764 13.5312368,27.5468284 L8,28.9999499 L9.5,23.6093378 C8.56249866,22.0155916 8.09374978,20.2812207 8.09374978,18.4062252 C8.09374978,16.5312297 8.56249866,14.7968588 9.5,13.2031126 C10.4374942,11.6093664 11.7031162,10.3437444 13.2968624,9.40624665 C14.8906086,8.46874888 16.6249794,8 18.499975,8 Z M15.3593575,13.6249866 L14.7968588,13.6249866 C14.5468596,13.6249866 14.3124852,13.7343611 14.0937355,13.9531108 L14.0937355,13.9531108 L14.0468606,13.9999857 C13.4843619,14.5937345 13.2031126,15.2968578 13.2031126,16.1093557 C13.2031126,16.9218535 13.5468615,17.8124764 14.2343601,18.7812243 L14.2343601,18.7812243 L14.3281099,18.8749741 C15.6406068,20.7499696 17.0937283,22.0312163 18.6874745,22.7187149 C19.4687229,23.0624638 20.0937212,23.2812136 20.56247,23.3749633 C20.9687193,23.437463 21.3905933,23.437463 21.828092,23.3749633 C22.1093414,23.3437132 22.4452783,23.1952765 22.8359021,22.9296519 C23.226526,22.6640273 23.4765258,22.3984034 23.5859003,22.1327788 C23.6952748,21.8671542 23.7577752,21.6093423 23.7733999,21.3593431 C23.7890246,21.109344 23.7812123,20.9530939 23.7499624,20.8905943 C23.7187123,20.8280947 23.5937131,20.7499696 23.3749633,20.6562198 L23.3749633,20.6562198 L23.2343387,20.56247 C22.2968409,20.0937212 21.7030921,19.8124718 21.4530929,19.7187221 C21.328093,19.6874719 21.2187185,19.6718472 21.1249687,19.6718472 C21.0312189,19.6718472 20.9530939,19.7343468 20.8905943,19.8593467 C20.7343449,20.0780964 20.4530955,20.4218454 20.0468463,20.8905943 C19.9218463,21.0468437 19.7343468,21.0624691 19.4843476,20.9374692 C18.6093495,20.4999704 17.953101,20.1093459 17.5156023,19.7655969 C16.9218535,19.2968481 16.4062297,18.6562244 15.968731,17.8437265 C15.8749812,17.7499768 15.8437311,17.6640397 15.8749812,17.5859146 C15.9062314,17.5077896 15.9843557,17.4062278 16.1093557,17.2812279 C16.3593548,17.0312287 16.5624798,16.7499794 16.7187292,16.4374799 C16.7812288,16.3124799 16.7656041,16.1562306 16.6718543,15.968731 L16.6718543,15.968731 L15.8749812,14.0468606 C15.8124816,13.859361 15.7421693,13.7421738 15.6640442,13.6952989 C15.5859192,13.648424 15.4843574,13.6249866 15.3593575,13.6249866 L15.3593575,13.6249866 Z"
										id="t"
										fill="#FFFFFF"
										fillRule="nonzero"
									></path>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case 'facebook-black':
			icon = (
				<svg {...svgProps} width="37px" height="37px" viewBox="0 0 37 37">
					<g id="Design_Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="Desktop_tvbee_lobby_Recomendetaions" transform="translate(-887.000000, -878.000000)">
							<g id="Share_Icons" transform="translate(887.000000, 877.000000)">
								<g id="facebook" transform="translate(0.000000, 1.000000)">
									<circle id="Oval-Copy-2" fill="#212F3B" cx="18.5" cy="18.5" r="18.5"></circle>
									<g id="Group-3" transform="translate(13.000000, 8.000000)" fill="#FFFFFF">
										<path
											d="M2.20313032,21 L6.61024158,21 L6.61024158,10.5584572 L9.41221504,10.5584572 C9.5525689,10.5584572 9.66995577,10.4516362 9.68186458,10.312853 L9.95151412,7.16205391 C9.96427356,7.00476629 9.84008166,6.87102976 9.68101395,6.87102976 L6.61024158,6.87102976 L6.61024158,4.63535867 C6.61024158,4.11134698 7.03980946,3.68658629 7.56975162,3.68658629 L9.72949983,3.68658629 C9.87835999,3.68658629 10,3.56630753 10,3.41911323 L10,0.268314175 C10,0.120278768 9.87835999,0 9.72949983,0 L6.08029942,0 C3.93926506,0 2.20313032,1.71586494 2.20313032,3.83378059 L2.20313032,6.87102976 L0.2713508,6.87102976 C0.121640014,6.87102976 0,6.99130853 0,7.13934393 L0,10.290143 C0,10.4381784 0.121640014,10.5584572 0.2713508,10.5584572 L2.20313032,10.5584572 L2.20313032,10.7258381 L2.20313032,21 Z"
											id="Fill-1"
										></path>
									</g>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case 'mail-black':
			icon = (
				<svg {...svgProps} width="37px" height="37px" viewBox="0 0 37 37">
					<g id="Design_Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="Desktop_tvbee_lobby_Recomendetaions" transform="translate(-997.000000, -877.000000)">
							<g id="Share_Icons" transform="translate(887.000000, 877.000000)">
								<g id="Group-2" transform="translate(110.000000, 0.000000)">
									<circle id="Oval" fill="#212F3B" cx="18.5" cy="18.5" r="18.5"></circle>
									<path
										d="M9.00014634,12.0001913 L9.00014634,22.6784529 C9.00014634,24.5049731 10.089252,26.0001913 11.4209592,26.0001913 L25.5793334,26.0001913 C26.9110406,26.0001913 28.0001463,24.5049731 28.0001463,22.6784529 L28.0001463,12.0786576 L9.00014634,12.0001913 Z"
										id="Fill-1"
										fill="#FFFFFF"
									></path>
									<path
										d="M16.1229569,21.2300121 C16.1748304,21.2765864 16.2296513,21.3171121 16.2891879,21.3527989 C17.004806,21.7846695 17.7658135,22 18.5197473,22 C19.2742706,22 20.0223097,21.7846695 20.7114016,21.3527989 C20.7632751,21.3207412 20.8122012,21.2844496 20.85818,21.243319 L29.0659785,13.9444628 C29.0712837,13.939019 29.07541,13.9323656 29.0818942,13.9275267 L30.1111111,13.0359617 C29.6654708,11.8468052 28.5802541,11 27.3134803,11 L9.66529875,11 C8.42269324,11 7.35044492,11.812933 6.88888889,12.9670076 L8.31481999,14.2142307 L16.1229569,21.2300121 Z"
										id="Fill-4"
										fill="#212F3B"
									></path>
									<path
										d="M16.5551466,20.3700099 C16.5975885,20.4081161 16.6424419,20.4412735 16.6911537,20.4704718 C17.2766595,20.8238205 17.8993019,21 18.5161569,21 C19.1334941,21 19.7455261,20.8238205 20.3093286,20.4704718 C20.3517705,20.4442428 20.391801,20.4145497 20.42942,20.3808974 L27.1448915,14.4091059 C27.1492321,14.4046519 27.1526082,14.3992082 27.1579134,14.3952491 L28,13.6657869 C27.6353852,12.6928406 26.7474806,12 25.7110293,12 L11.2716081,12 C10.2549308,12 9.37763676,12.665127 9,13.6093698 L10.1666709,14.6298251 L16.5551466,20.3700099 Z"
										id="Fill-4"
										fill="#FFFFFF"
									></path>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case 'accessibility':
			icon = (
				<svg {...svgProps} width="47.797" height="47.797" viewBox="0 0 47.797 47.797">
					<path
						id="Path_1272"
						data-name="Path 1272"
						d="M23.9 0A23.9 23.9 0 1 1 0 23.9 23.9 23.9 0 0 1 23.9 0z"
						fill="#d9000d"
					/>
					<g id="XMLID_28_" transform="translate(14.059 11.246)">
						<path
							id="XMLID_31_"
							className="cls-2"
							d="M179.226 4.8a2.4 2.4 0 1 0-2.4-2.4 2.4 2.4 0 0 0 2.4 2.4z"
							transform="translate(-170.409)"
							fill="#fff"
						/>
						<path
							id="XMLID_30_"
							className="cls-2"
							d="M59.908 207.157a5.309 5.309 0 1 1-7.238-6.325v-2.252a7.425 7.425 0 1 0 8.874 10.22l-.839-1.648z"
							transform="translate(-47.38 -188.741)"
							fill="#fff"
						/>
						<path
							id="XMLID_29_"
							className="cls-2"
							d="m195.439 132.752-3.218-6.326a1.409 1.409 0 0 0-1.257-.771h-4.121v-.94h3.547a1.109 1.109 0 0 0 1.058-1.058 1.058 1.058 0 0 0-1.058-1.058h-3.547v-3.187a2.116 2.116 0 1 0-4.231 0v6.906a2.158 2.158 0 0 0 2.158 2.158h5.33l2.825 5.555a1.41 1.41 0 1 0 2.514-1.279z"
							transform="translate(-175.913 -111.484)"
							fill="#fff"
						/>
					</g>
				</svg>
			);
			break;
		case 'like':
			icon = (
				<svg {...svgProps} width="25px" height="26px" viewBox="0 0 25 26">
					<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="Desktop/-Buttons/-Default" transform="translate(-20.000000, -4.000000)">
							<g id="thumb_up_black_24dp" transform="translate(20.168868, 4.567093)">
								<polygon
									id="Path"
									points="0 0 24.4020945 0 24.4020945 24.6784781 0 24.6784781"
								></polygon>
								<path
									d="M5,18 L7.90909091,18 L7.90909091,9.6 L5,9.6 L5,18 Z M21,10.3 C21,9.53 20.3454545,8.9 19.5454545,8.9 L14.9563636,8.9 L15.6472727,5.701 L15.6690909,5.477 C15.6690909,5.19 15.5454545,4.924 15.3490909,4.735 L14.5781818,4 L9.79272727,8.613 C9.52363636,8.865 9.36363636,9.215 9.36363636,9.6 L9.36363636,16.6 C9.36363636,17.37 10.0181818,18 10.8181818,18 L17.3636364,18 C17.9672727,18 18.4836364,17.65 18.7018182,17.146 L20.8981818,12.211 C20.9636364,12.05 21,11.882 21,11.7 L21,10.3 Z"
									id="Shape"
									fill="#000000"
									fillRule="nonzero"
								></path>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case 'arrow-left':
			icon = (
				<svg {...svgProps} width="22.087" height="19.67" viewBox="0 0 22.087 19.67">
					<defs></defs>
					<g
						id="Icon_feather-download"
						data-name="Icon feather-download"
						transform="translate(21.087 1.414) rotate(90)"
					>
						<path
							id="Path_20"
							data-name="Path 20"
							className="cls-1"
							d="M0,0,8.421,8.37,16.842,0"
							transform="translate(0 11.717)"
							fill="none"
							stroke={color}
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
						/>
						<path
							id="Path_21"
							data-name="Path 21"
							className="cls-1"
							d="M0,20.087V0"
							transform="translate(8.421)"
							fill="none"
							stroke={color}
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
						/>
					</g>
				</svg>
			);
			break;
		case 'refresh':
			icon = (
				<svg width="14px" height="14px" viewBox="0 0 14 14">
					<g id="Design_Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g
							id="Desktop_tvbee_lobby_Recomendetaions"
							transform="translate(-1136.000000, -759.000000)"
							fill="#000000"
							fillRule="nonzero"
						>
							<g id="Group-7" transform="translate(645.000000, 665.000000)">
								<g id="Group" transform="translate(379.000000, 86.689879)">
									<path
										d="M123.935,9.36637101 C122.66625,8.09762101 120.925,7.31012101 118.99125,7.31012101 C115.12375,7.31012101 112,10.442621 112,14.310121 C112,18.177621 115.12375,21.310121 118.99125,21.310121 C122.255,21.310121 124.97625,19.078871 125.755,16.060121 L123.935,16.060121 C123.2175,18.098871 121.275,19.560121 118.99125,19.560121 C116.095,19.560121 113.74125,17.206371 113.74125,14.310121 C113.74125,11.413871 116.095,9.06012101 118.99125,9.06012101 C120.44375,9.06012101 121.73875,9.66387101 122.68375,10.617621 L119.86625,13.435121 L125.99125,13.435121 L125.99125,7.31012101 L123.935,9.36637101 Z"
										id="switch"
									></path>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case 'instagram':
			icon = (
				<svg width="22" height="22" viewBox="0 0 22 22">
					<defs>
						<path id="4mtpv4rqua" d="M0 0h22v22H0z" />
					</defs>
					<g fill="none" fillRule="evenodd">
						<mask id="cch9h9b4lb" fill="#fff">
							<use xlinkHref="#4mtpv4rqua" />
						</mask>
						<path
							d="M19.925 15.373a4.551 4.551 0 0 1-4.552 4.552H6.627a4.552 4.552 0 0 1-4.552-4.552V6.626a4.552 4.552 0 0 1 4.552-4.551h8.746a4.551 4.551 0 0 1 4.552 4.551v8.747zM22 6.626A6.626 6.626 0 0 0 15.373 0H6.627A6.626 6.626 0 0 0 0 6.626v8.747A6.627 6.627 0 0 0 6.627 22h8.746A6.627 6.627 0 0 0 22 15.373V6.626zm-10.963 7.996a3.484 3.484 0 0 1-3.48-3.48c0-1.92 1.562-3.48 3.48-3.48 1.92 0 3.48 1.56 3.48 3.48a3.484 3.484 0 0 1-3.48 3.48zm0-8.913a5.44 5.44 0 0 0-5.433 5.433 5.44 5.44 0 0 0 5.433 5.433 5.44 5.44 0 0 0 5.434-5.433 5.44 5.44 0 0 0-5.434-5.433zm5.75-1.659a1.293 1.293 0 1 0 0 2.587 1.293 1.293 0 0 0 0-2.587z"
							fill="#FFF"
							mask="url(#cch9h9b4lb)"
						/>
					</g>
				</svg>
			);
			break;
		case 'error':
			icon = (
				<svg width="14px" height="14px" viewBox="0 0 14 14">
					<title>Error</title>
					<g id="Design_Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="Desktop_tvbee_lobby_Recomendetaions" transform="translate(-1145.000000, -727.000000)">
							<g id="Group-7" transform="translate(645.000000, 665.000000)">
								<g id="Watching" transform="translate(362.000000, 60.000000)">
									<g id="Error" transform="translate(138.000000, 2.000000)">
										<circle id="Oval" fill="#B52600" cx="7" cy="7" r="7"></circle>
										<g
											id="!"
											transform="translate(6.260483, 3.147461)"
											fill="#FFFFFF"
											fillRule="nonzero"
										>
											<path
												d="M1.60595703,5.24755859 L0.295410156,5.24755859 L0.021484375,0 L1.87988281,0 L1.60595703,5.24755859 Z M0,7.07910156 C0,6.78190104 0.0805664062,6.5563151 0.241699219,6.40234375 C0.402832031,6.2483724 0.634684245,6.17138672 0.937255859,6.17138672 C1.23982747,6.17138672 1.47257487,6.25016276 1.63549805,6.40771484 C1.79842122,6.56526693 1.87988281,6.78816732 1.87988281,7.07641602 C1.87988281,7.36466471 1.79663086,7.59025065 1.63012695,7.75317383 C1.46362305,7.91609701 1.23266602,7.99755859 0.937255859,7.99755859 C0.641845703,7.99755859 0.411783854,7.91788737 0.247070312,7.75854492 C0.0823567708,7.59920247 0,7.37272135 0,7.07910156 Z"
												id="Shape"
											></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		default:
			break;
	}

	return (
		<i className={classNames(css.icon, className)} {...iconProps}>
			{icon}
		</i>
	);
};

Icon.defaultProps = {
	className: '',
	width: 24,
	height: 24,
	color: '#111',
};

export { Icon };
